import axios from 'axios'

// нужны для отправки post запросов в Django
const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'

const session = axios.create({
	baseURL: 'backend/rest/v1',
	Accept: "application/json; indent=4",
	withCredentials: true,
	xsrfCookieName: CSRF_COOKIE_NAME,
	xsrfHeaderName: CSRF_HEADER_NAME,
})



export default session